export default __webpack_public_path__ + "static/media/Intro.eba9978a.svg";